export default {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    isStreamGroupUpdate: 0,
    streamGroupId: 0,
    streamGroupName: '',
    isStreaming: 0,
    streamGroupContentList: [],
    /*
    streamGroupContentListの構造
    streamGroupContentList: {
      contentId: 0,
      templateId: 0,
      isIncludeMovie: 0,
      contentDuration: 0,
      contentCreateDate: '',
      contentMaterialList: {
        contentMaterialUrl: '',
        offsetX: 0,
        offsetY: 0,
        scale: 0,
      }
    */
    /*
      streamGroupUploadingListの構造
      streamGroupUploadingList: {
        streamGroupMovieUrl: '',
        streamGroupUploadStatus: '',
        createTime: '',
        contentCount: 0,
        streamGroupName: '',
        streamGroupDuration: '',
      }
    */
  },
  mutations: {
    setIsStreamGroupUpdate(state, isStreamGroupUpdate) {
      state.isStreamGroupUpdate = isStreamGroupUpdate;
    },
    setStreamGroupId(state, streamGroupId) {
      state.streamGroupId = streamGroupId;
    },
    setStreamGroupName(state, streamGroupName) {
      state.streamGroupName = streamGroupName;
    },
    setIsStreaming(state, isStreaming) {
      state.isStreaming = isStreaming;
    },
    setStreamGroupContentList(state, streamGroupContentList) {
      state.streamGroupContentList = streamGroupContentList;
    },
  },
  getters: {
    getIsStreamGroupUpdate: (state) => {
      return state.isStreamGroupUpdate;
    },
    getStreamGroupId: (state) => {
      return state.streamGroupId;
    },
    getStreamGroupName: (state) => {
      return state.streamGroupName;
    },
    getIsStreaming: (state) => {
      return state.isStreaming;
    },
    getStreamGroupContentList: (state) => {
      return state.streamGroupContentList;
    },
  },
};
